import { flatMap } from 'lodash-es';
import * as C from '../constants';
import defaultState from './defaultState';

export default {

  [C.BOOKING_RESET_STATE](state) {
    Object.assign(state, defaultState());
  },

  // region Booking
  [C.BOOKING_BY_ID_LOAD_PENDING](state) {
    state.booking = {
      ...state.booking,
      itemLoading: true,
      itemError: undefined,
    };
  },

  [C.BOOKING_BY_ID_LOAD_FAILURE](state, payload) {
    state.booking = {
      ...state.booking,
      itemLoading: false,
      itemError: payload,
    };
  },

  [C.BOOKING_BY_ID_LOAD_SUCCESS](state, payload) {
    state.booking = {
      ...state.booking,
      id: payload.id,
      bookingRef: payload.bookingRef,
      currency: payload.currency,
      customer: payload.customer,
      stays: Object.values(payload.bookingStays),
      itemLoading: false,
      itemError: undefined,
    };
  },
  // endregion

  // region Participants
  [C.BOOKING_STAY_PARTICIPANTS_BY_STAY_IDS_LOAD_PENDING](state) {
    state.participants = {
      ...state.participants,
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.BOOKING_STAY_PARTICIPANTS_BY_STAY_IDS_LOAD_FAILURE](state, payload) {
    state.participants = {
      ...state.participants,
      itemsLoading: false,
      itemsError: payload,
    };
  },

  [C.BOOKING_STAY_PARTICIPANTS_BY_STAY_IDS_LOAD_SUCCESS](state, payload) {
    const participants = flatMap(payload, stayId => stayId.map(participant => ({
      id: participant.id,
      bookingStayId: participant.bookingStayId,
      firstName: participant.firstName,
      lastName: participant.lastName,
      birthday: participant.birthday,
      validBirthday: participant.validBirthday,
      age: participant.age,
      areaId: participant.areaId,
    })));
    state.participants = {
      ...state.participants,
      items: participants,
      itemsLoading: false,
      itemsError: undefined,
    };
  },
  // endregion

  // region Area
  [C.BOOKING_STAY_AREA_PENDING](state) {
    state.areas = {
      ...state.areas,
      itemsLoading: true,
      itemsError: undefined,
    };
  },

  [C.BOOKING_STAY_AREA_SUCCESS](state, payload) {
    let items = state.areas.items;
    const areaIds = Object.values(items).map(area => area.id);
    if (!areaIds.includes(payload.id)) {
      const areaItem = {
        id: payload.id,
        name: payload.name,
      };
      items = [
        ...items,
        areaItem,
      ];
    }
    state.areas = {
      ...state.areas,
      items,
      saveLoading: false,
      saveError: undefined,
    };
  },

  [C.BOOKING_STAY_AREA_FAILURE](state, payload) {
    state.areas = {
      ...state.areas,
      itemsLoading: false,
      itemsError: payload,
    };
  },
  // endregion
};



// WEBPACK FOOTER //
// ./src/store/modules/booking/mutations.js